import React from "react";
import { Product } from "../types/Product";
import "./ProductTile.css";

interface ProductTileProps {
  product: Product;
  onAddToCart?: (product: Product) => void;
}

export const ProductTile: React.FC<ProductTileProps> = ({
  product,
  onAddToCart,
}) => {
  const { image, title, price, description } = product;

  const handleAddToCart = () => {
    if (onAddToCart) {
      onAddToCart(product);
    }
  };

  return (
    <div className="product-tile">
      <img src={image} alt={title} className="product-image" />
      <h3 className="product-title">{title}</h3>
      <p className="product-price">R {price.toFixed(2)}</p>
      <p className="product-description">{description}</p>

      <button
        className="add-to-cart-btn"
        onClick={handleAddToCart}
        aria-label={`Add ${title} to cart`}
      >
        Add to Cart
      </button>
    </div>
  );
};
